// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CBcn","index":"styles_index__23tDq"};